<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <!-- placeholder="DD/MM/YYYY" -->
    <FormulateInput v-if="client"
        type="radio"
        :name="context.name"
        :options="getDrivers"
        :placeholder="context.placeholder"
        v-model="context.model"
        @change="populateDriver" />

    <div class="notification is-info-palegreen mt-3" v-if="context.model && context.model !== 'new-driver'">
      We have populated some of your driver answers based on what you told us last time
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  mounted () {

  },
  computed: {
    ...mapGetters({ client: 'client', answers: 'flattenedAnswers'}),

    getDrivers () {
      let options = [...this.context.options];
      
      if (this.$store.getters.client.drivers) {

        (this.$store.getters.client.drivers).forEach(function(driver){
          options.push(
            {
              id: 'maindriver_' + driver.driver_id,
              label: driver.first_name + ' ' + driver.last_name, // + ' (' + fulltextDate(driver.dob) + ')',
              value: driver.driver_id.toString()
            });
        });

        // move first element (new-driver) to last element
        options.push(options.shift());

      } else {
        // Hide this input when no drivers, as its confusing
        // But still keep the value in as more fields are dependant on this being 'new-driver'
        this.$emit('hide-this-element');
      }

      return options;
    }
  },
  methods: {
    populateDriver(){
      // console.log('populate driver');
      var driver_id = this.context.model;

      // Prevent error if no drivers
      if( ! this.$store.getters.client.drivers ){
        return;
      }

      this.$store.commit('setDriver', driver_id);
    }
  }
}
</script>

<style>

.formulate-input-element--maindriver .formulate-input[data-type="radio"][data-classification="group"] .formulate-input-group {
    flex-wrap: wrap;
    gap: 0.8rem;
}

.formulate-input-element--maindriver .formulate-input-group-item[data-type="radio"] {
    flex-basis: calc(50% - 0.4rem);
}

.formulate-input-element--maindriver .formulate-input[data-type="radio"][data-classification="group"] .formulate-input-group > [data-type="radio"] .formulate-input-label--after {
    margin-right: 0;
}

</style>